import React from 'react';

import pickDefined from '../../util/pickDefined';
import {SingleValueFilter} from '../SearchConstants';
import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';
import SecondaryFilterFormSkeleton from './base/SecondaryFilterFormSkeleton';

interface StarredFilterFormProps extends BaseFilterFormProps {
  filter: SingleValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: SingleValueFilter) => void;
  onChangeValue: (e: string) => void;
  onRemove: () => void;
  value: string;
}

const StarredFilterForm: React.FC<StarredFilterFormProps> = (props: StarredFilterFormProps): JSX.Element => {
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  return (
    <SecondaryFilterFormSkeleton
      {...skeletonProps}
      nodeGrid={[[]]}
      onChangeFilterKey={props.onChangeFilterKey}
      selectedFilterKey={props.selectedFilterKey}
      onRemove={props.onRemove}
    />
  );
};

export default StarredFilterForm;
